import React, { Component } from 'react';
import { ButtonToolbar, FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import ToggleButtonGroup from 'react-bootstrap/lib/ToggleButtonGroup'
import ToggleButton from 'react-bootstrap/lib/ToggleButton'

class ValidateIO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      outputValue: '',
      errorValue: '',
      validate: 'json',
      validationState: null
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateErrorOutput = this.updateErrorOutput.bind(this);
    this.validateJSON = this.validateJSON.bind(this);
  }

  validateJSON(str) {
    let result = ''
    try {
      if(str === '') {
        this.setState({...this.state, validationState: null, errorValue: ''});
      } else {
        JSON.parse(str)
        result = 'Valid';
        this.setState({...this.state, validationState: 'success', errorValue: ''});
      }
    } catch (e) {
      this.updateErrorOutput(e)
    }
    return result;
  }

  updateErrorOutput(event) {
    let errorValue = '';
    errorValue = event.stack.substring(0, event.stack.indexOf('at JSON.parse (<anonymous>)'));
    this.setState({errorValue: errorValue, validationState: 'error'})
  }

  handleInputChange(event) {
    this.setState({outputValue: this.validateJSON(event.target.value)});
  }



  render() {
    return (
      <div>
        {this.props.children}
        <FormGroup controlId="formControlsTextarea" className="top-buffer" validationState={this.state.validationState} >
          <ControlLabel>Input</ControlLabel>
          <ButtonToolbar className="top-buffer">
            <ToggleButtonGroup onChange={this.handleDecodeChange} type="radio" name="encode" defaultValue={this.state.validate}>
              <ToggleButton value={'json'}>JSON</ToggleButton>
            </ToggleButtonGroup>
          </ButtonToolbar>
          <FormControl className="top-buffer" onChange={this.handleInputChange} componentClass="textarea" placeholder="String Input"/>
        </FormGroup>
        {this.state.errorValue !== '' ?
          <FormGroup controlId="formControlsTextarea" className="top-buffer" validationState={this.state.validationState} >
            <ControlLabel>Error</ControlLabel>
            <div className="error-box s">
              <code>{this.state.errorValue}</code>
            </div>
          </FormGroup>
        : '' }
      </div>
    );
  }
}

export default ValidateIO;



// WEBPACK FOOTER //
// ./src/components/ValidateIO/ValidateIO.js